import { render, staticRenderFns } from "./Setemail.vue?vue&type=template&id=1488dc34"
import script from "./Setemail.vue?vue&type=script&lang=js"
export * from "./Setemail.vue?vue&type=script&lang=js"
import style0 from "./Setemail.vue?vue&type=style&index=0&id=1488dc34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports